import { render, staticRenderFns } from "./RouteInfoV2Page.vue?vue&type=template&id=9c344870&"
import script from "./RouteInfoV2Page.vue?vue&type=script&lang=ts&"
export * from "./RouteInfoV2Page.vue?vue&type=script&lang=ts&"
import style0 from "./RouteInfoV2Page.vue?vue&type=style&index=0&id=9c344870&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports